export default "__VITE_PUBLIC_ASSET__e576e0c8__"